import { SVGProps, ReactElement } from 'react';

export function CheckboxOutlineBlankIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg fill='#fff' stroke='#ccc' height='20' width='20' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect height='19' rx='3.5' width='19' x='.5' y='.5' />
    </svg>
  );
}
